import { post } from "aws-amplify/api";
import { fetchUserAttributes } from 'aws-amplify/auth';

export const createStripeAccount = async () => {
    try {
        const user = await fetchUserAttributes();
        const { body } = await post({
            apiName: 'stripeApi',
            path: '/stripe/create-stripe-account',
            options: {
                body: {
                    email: user.email,
                    userSub: user.sub
                }
            }
        }).response;

        const data = await body.json();

        return data;
    } catch (error) {
        console.error("Error:", error);
        return null
    }
}

/**
 * Check the status of an existing Stripe account
 */
export const checkStripeAccountStatus = async (stripeAccountId) => {
    try {
        const restOperation = post({
            apiName: 'stripeApi',
            path: '/stripe/check-stripe-account',
            options: {
                body: {
                    stripeAccountId
                }
            }
        });
        const { body } = await restOperation.response;
        const data = await body.json(); // e.g. { id: "acct_xxx", charges_enabled: true/false, ... }

        return data;
    } catch (error) {
        console.error("Error checking Stripe account status:", error);
        return null;
    }
};

/**
 * Regenerate Stripe onboarding link for an existing Stripe account
 */
export const regenerateStripeAccountLink = async (stripeAccountId) => {
    try {
        const restOperation = post({
            apiName: 'stripeApi',
            path: '/stripe/regenerate-stripe-link',
            options: {
                body: {
                    stripeAccountId
                }
            }
        });
        const { body } = await restOperation.response;
        const data = await body.json(); // e.g. { url: "https://connect.stripe.com/..." }

        return data;
    } catch (error) {
        console.error("Error regenerating Stripe link:", error);
        return null;
    }
};

/**
 * Create a new Stripe Checkout session
 */
export const createCheckoutSession = async (amount, currency, successUrl, cancelUrl, userSub) => {
    try {
        const restOperation = post({
            apiName: 'stripeApi',
            path: '/stripe/create-checkout-session',
            options: {
                body: { amount, currency, success_url: successUrl, cancel_url: cancelUrl, userSub},
            },
        });

        const { body } = await restOperation.response;
        return await body.json(); // Expect { url: "https://checkout.stripe.com/..." }
    } catch (error) {
        console.error("Error creating checkout session:", error);
        return null;
    }
};
